import * as actionTypes from "./actionTypes"

export function addToCart(payload: Product) {
    return {
        type: actionTypes.ADD_TO_CART,
        payload
    }
}
  
export function clearCart() {
    return {
        type: actionTypes.CLEAR_CART
    }
}

export function removeFromCart(payload: Product) {
    return {
        type: actionTypes.REMOVE_FROM_CART,
        payload
    }
}

export function updateQuantity(payload: { product: Product; quantity: number }) {
    return {
        type: actionTypes.UPDATE_QUANTITY,
        payload
    }
}